(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .directive('usageStatistics', UsageStatisticsDirective);

  function UsageStatisticsDirective() {
    return {
      restrict: 'E',
      templateUrl: 'views/directives/usage-statistics.html',
      controller: 'UsageStatisticsCtrl',
      controllerAs: 'stats'
    };
  }
}());
